import styled from 'styled-components';

import { StickyLayout } from '@/components/StickyLayout';

export const RetailerMain = styled(StickyLayout.Main)`
  &&& {
    margin-top: 0;
  }
`;
